import { inject, Injectable } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs";

@Injectable({ providedIn: "root" })
export class NavigationHistoryService {
  private readonly router = inject(Router);

  private _lastNonCrmUrl = "/home";
  private _returnUrl = "/home";

  constructor() {
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe((e) => {
        if (!e.urlAfterRedirects.includes("/crm")) {
          this._lastNonCrmUrl = e.urlAfterRedirects;
        } else {
          // Entering or navigating within CRM — lock in the last non-CRM URL
          this._returnUrl = this._lastNonCrmUrl;
        }
      });
  }

  get returnUrl(): string {
    return this._returnUrl;
  }
}
